import { ActionPinComment } from 'feature/question/pin-comment';
import { component, demoFile, CLICK, story, variant, componentWithVariants } from 'system/demo';

demoFile('feature/question/pin-comment');

componentWithVariants('ActionPinComment', ActionPinComment, { args: { commentKey: '1' } }, [
    variant('Unpinned', { state: { roles: ['Owner'], globals: { pinned_comments: {} } } }, [
        story('Pin', [CLICK('Feature')])
    ]),
    variant('Pinned', { state: { roles: ['Owner'], globals: { pinned_comments: { '1': true } } } }, [
        story('Unpin', [CLICK('Featured')])
    ])
]);
